import React, { useEffect, useState, useRef } from 'react'
import { useHistory, Link } from 'react-router-dom'
import JoditEditor from "jodit-react"
import api from '../components/api';
import axios from 'axios'
import InputMask from 'react-input-mask'
import { dataTableRender } from '../components/functions'
import AnexoBibl from '../modals/anexoBibl'


const BibliotecaEdit = (props) => {


    //var linkAPI = 'http://172.16.1.253:3700/'
    var linkAPI = 'https://cdn.hospitaissaudaveis.org/'

    var ad_usr = sessionStorage.getItem('us_codigo')
    //console.log(ad_usr)

    const history = useHistory()

    var [bibl_id, setBibl_id] = useState(props.match.params.bibl_id)
    var [titulo, setTitulo] = useState('')
    var [texto, setTexto] = useState('')

    var [tipoBibl_id, setTipoBibl_id] = useState()
    var [resultadoTipoBibl, setResultadoTipoBibl] = useState()

    var [ano, setAno] = useState('')
    var [idioma, setIdioma] = useState('')
    var [idioma_id, setIdioma_id] = useState()
    var [resumo, setResumo] = useState('')
    var [tags, setTags] = useState('')

    var [arquivo, setArquivo] = useState('')
    var [arquivoThumb, setArquivoThumb] = useState('')

    var [tema_id, setTema_id] = useState()
    var [resultadoTemas, setResultadoTemas] = useState()
    var [resultadoIdiomas, setResultadoIdiomas] = useState()

    var [conteudoAnexos, setConteudoAnexos] = useState()
    var [oculto, setOculto] = useState(false)




    const editor = useRef(null)
    const [content, setContent] = useState('')


    async function carregaTemas() {


        await api.get('temas').then((result) => {

            setResultadoTemas(result.data.map((rs) => 

                <option key={rs.tema_id} value={rs.tema_id}>{rs.tema_descri}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    async function carregaIdiomas() {


        await api.get('idiomas').then((result) => {

            setResultadoIdiomas(result.data.map((rs) => 

                <option key={rs.idioma_id} value={rs.idioma_id}>{rs.idioma_descri}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    async function carregaTiposBiblioteca() {


        await api.get('tiposBiblioteca').then((result) => {

            setResultadoTipoBibl(result.data.map((rs) => 

                <option key={rs.tipoBibl_id} value={rs.tipoBibl_id}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }

    async function carregaDados() {

        if (bibl_id) {


            await api.get(`bibl/${bibl_id}`).then((result) => {

                console.log(result.data)
                var data = result.data[0]

                setTipoBibl_id(data.tipoBibl_id)
                setTitulo(data.titulo)
                setAno(data.ano)
                setResumo(data.resumo)
                setTexto(data.texto)
                setContent(data.texto)
                setIdioma(data.idioma)
                setArquivo(data.arquivo)
                setArquivoThumb(data.thumb)
                setTema_id(data.tema_id)
                setIdioma_id(data.idioma_id)
                setTags(data.tags)
                setOculto(data.oculto == null ? false : data.oculto)

            }).catch((err) => {

                console.log(err.response)

            })


        }

    }



    useEffect(() => {
 
        carregaTiposBiblioteca()
        carregaIdiomas()
        carregaTemas()
        carregaDados()

        //dataTableRender('tabelaAnexos')

    }, [])



    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 500,
        placeholder: 'Escreva aqui...',
      })



    const apagar = () => {




        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    api.delete(`bibl/${bibl_id}`).then((result) => {

                        console.log(result.data)
                        window.toastr.success('Apagado com sucesso!')
                        history.push('/Biblioteca')

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        

    }


    function salvar() {

        

        if (titulo == '') {

            window.toastr.error('<b>Título</b> não pode ficar em branco!')
            return false

        }

        if (ano == '') {

            //window.toastr.error('<b>Ano</b> não pode ficar em branco!')
            //return false

        }

        if (idioma_id == '') {

            window.toastr.error('<b>Idioma</b> não pode ficar em branco!')
            return false

        }

        if (resumo == '') {

            window.toastr.error('<b>Resumo</b> não pode ficar em branco!')
            return false

        }

        if (tema_id == '') {

            window.toastr.error('<b>Tema</b> não pode ficar em branco!')
            return false

        }


        //console.log(tags)
        //return false

        //console.log(linkAPI)
        //return false

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    //console.log(tema_id)
                    //return false

                    const formData = new FormData();
                    const imagefile = document.querySelector("#arquivoBiblioteca1");
                    const imagefileThumb = document.querySelector("#arquivoBiblioteca2")


                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    //formData.append("imagem", imagefile.files[0]);

                    //formData.append("imagem", filesArray)
                    formData.append("imagem", imagefile.files[0]);
                    formData.append("imagemThumb", imagefileThumb.files[0]);
                    formData.append("tipoBibl_id", tipoBibl_id); // string junto ao formData.
                    formData.append("texto", texto)
                    formData.append("titulo", titulo)
                    formData.append("resumo", resumo)
                    formData.append("oculto", oculto)
                    //formData.append("ano", ano)
                    formData.append("idioma_id", idioma_id)
                    formData.append("tema_id", tema_id)
                    formData.append("tags", tags)

                    //console.log(formData)
                    //  return false


                    if (!isNaN(bibl_id)) {

                        //console.log('altera')
                        //return false

                        axios.put(`${linkAPI}bibl/${bibl_id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(result => {

                            console.log(result.data)
                            window.toastr.success('Salvo com sucesso!')


                        }).catch((err) => {

                            console.log(err.response)

                        })



                    } else {

                        //console.log('inclui')
                        //return false
                        


                        axios.post(linkAPI + 'bibl/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            console.log(response.data)
        
                            window.toastr.success('Salvo com sucesso!')




                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }



    async function carregaAnexos() {

        await api.get(`biblAnexo/${bibl_id}`).then((result) => {

            console.log(result.data)

            setConteudoAnexos(result.data.map((rs) =>
            
                <tr>
                    <td style={{ cursor: 'pointer'}} onClick={() => window.open(rs.linkArquivo)}>
                        <center>
                        {rs.nomeArquivo}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.ad_new}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.us_nome}
                        </center>
                    </td>
                    <td >
                        <center>
                        {rs.linkArquivo}
                        </center>
                    </td>
                    <td>
                        <center>
                        <Link onClick={() => apagaAnexo(rs.anexoBibl_id)}>[Apagar]</Link>
                        </center>
                    </td>
                </tr>
            
            
            ))

            dataTableRender('tabelaAnexos')

        }).catch((err) => {

            console.log(err.response)

        })

        

    }


    function apagaAnexo(anexoBibl_id) {

        

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log('apagar!')
                    api.delete(`biblAnexo/${anexoBibl_id}/${ad_usr}`).then((result) => {

                        console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Apagado com sucesso!')
                            carregaAnexos()

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }



    return (


        <div>
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Biblioteca</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-3">
                    <div class="form-group">
                        <label>Tipo</label>
                        <select class="form-control" placeholder="" value={tipoBibl_id} onChange={event => setTipoBibl_id(event.target.value)} >
                            <option value="">[Selecione]</option>
                            {resultadoTipoBibl}
                        </select>
                                        
                    </div>
                </div>

                <div class="col-md-3" style={{ display: 'none'}}>
                    <div class="form-group">
                        <label>Ano</label>
                        <InputMask mask="9999" class="form-control"  value={ano} onChange={event => setAno(event.target.value)}  />
                           
                                        
                    </div>
                </div>


                <div class="col-md-3">
                    <div class="form-group">
                        <label>Tema</label>
                        <select class="form-control" placeholder="" value={tema_id} onChange={event => setTema_id(event.target.value)} >
                            <option value="">[Selecione]</option>
                            {resultadoTemas}
                        </select>
                           
                                        
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>Idioma</label>
                        <select class="form-control" placeholder="" value={idioma_id} onChange={event => setIdioma_id(event.target.value)} >
                            <option value="">[Selecione]</option>
                            {resultadoIdiomas}
                        </select>
                           
                                        
                    </div>
                </div>


                <div class="col-md-3">
                    <div class="form-group">
                        <label>Link oculto</label>
                        <select class="form-control" placeholder="" value={oculto} onChange={event => setOculto(event.target.value)} >
                            <option value="">[Selecione]</option>
                            <option value={false}>Não</option>
                            <option value={true}>Sim</option>
                        </select>
                           
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Título</label>
                        <input type="text" class="form-control" placeholder="" value={titulo} onChange={event => setTitulo(event.target.value)} maxLength={500} />
                                        
                    </div>
                </div>


                <div class="col-md-12">
                    <div class="form-group">
                        <label>Tags</label>
                        <textarea type="text" class="form-control" placeholder="" rows="2" value={tags} onChange={event => setTags(event.target.value)} maxlength="500" />
                                        
                    </div>
                </div>


                <div class="col-md-12">
                    <div class="form-group">
                        <label>Resumo</label>
                        <textarea type="text" class="form-control" placeholder="" rows="4" value={resumo} onChange={event => setResumo(event.target.value)} maxlength="4000" />
                                        
                    </div>
                </div>



                <ul class="nav nav-tabs">
                    <li class="active"><a href="#tab1" data-toggle="tab">Corpo da página</a></li>
                    <li ><a href="#tab2" data-toggle="tab" >Anexos principais</a></li>
                    <li style={{ display: bibl_id ? 'block' : 'none'}} ><a href="#tab3" data-toggle="tab" onClick={() => carregaAnexos()}>Anexos adicionais</a></li>
                    
                </ul>
                
                <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1">
                        <div class="panel-body">

                            <div class="col-md-12">

                                <div class="form-group">
                                    <label>Texto</label>
                                            
                                    <JoditEditor 
                                        ref={editor}
                                        value={content}
                                        config={config}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                                        onChange={newContent => {}}
                                    />

                                                    
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade in" id="tab2">

                        <div class="panel-body">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Arquivo Thumb</label>
                                    <input type="text" className="form-control" placeholder="" value={arquivoThumb} readOnly style={{cursor: 'pointer' }} onClick={() => window.open(`${linkAPI}uploads/biblioteca/${arquivoThumb}`)}/>
                                    
                                                    
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Arquivo Imagem</label>
                                    <input type="file" class="form-control" id="arquivoBiblioteca2" />
                                                    
                                </div>
                            </div>


                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Arquivo íntegra atual</label>
                                    <input type="text" className="form-control" placeholder="" value={arquivo} readOnly style={{cursor: 'pointer' }} onClick={() => window.open(`${linkAPI}uploads/biblioteca/${arquivo}`)}/>
                                    
                                                    
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Arquivo PDF</label>
                                    <input type="file" class="form-control" id="arquivoBiblioteca1" />
                                                    
                                </div>
                            </div>


                        </div>

                    </div>
                    <div class="tab-pane fade in" id="tab3">

                        <div class="panel-body">

                            
                            <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalAnexoBibl" >+ Novo</button>
                            <br/><br/><br/>
                                
                                <div className="table-responsive">
                                    <table id="tabelaAnexos" className="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '220px'}}>Arquivo</th>
                                                <th style={{ width: '220px'}}><center>Incluso em</center></th>
                                                <th style={{ width: '120px'}}><center>Por</center></th>
                                                <th><center>Link</center></th>
                                                <th style={{ width: '20px'}}><center>&nbsp;</center></th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {conteudoAnexos}
                                            
                                        </tbody>
                                        
                                    </table>
                                
                                </div>


                        </div>
                    </div>
                </div>


                


                
                

                <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => history.push('/Biblioteca')}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-danger" onClick={() => apagar()} style={{ display: !isNaN(bibl_id) ? 'table-row' : 'none' }}>Apagar</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                </div>

            </div>



            <AnexoBibl bibl_id={bibl_id} carregaAnexos={carregaAnexos} />


        </div>


    )


}

export default BibliotecaEdit